import { render, staticRenderFns } from "./StarterSettings.vue?vue&type=template&id=58d49904&scoped=true"
import script from "./StarterSettings.vue?vue&type=script&lang=js"
export * from "./StarterSettings.vue?vue&type=script&lang=js"
import style0 from "./StarterSettings.vue?vue&type=style&index=0&id=58d49904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d49904",
  null
  
)

export default component.exports